export { default as Img200 } from './processed/200/Fifty-Shades-Freed.jpg';
export { default as Img400 } from './processed/400/Fifty-Shades-Freed.jpg';
export { default as Imgthumb } from './processed/thumb/Fifty-Shades-Freed.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Fifty-Shades-Freed.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Fifty-Shades-Freed.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      18,
      164,
      237
    ],
    "_population": 0
  },
  "DarkVibrant": {
    "_rgb": [
      4,
      36,
      52
    ],
    "_population": 6798,
    "_hsl": [
      0.5555555555555556,
      0.8571428571428571,
      0.10980392156862745
    ]
  },
  "Muted": {
    "_rgb": [
      133,
      126,
      122
    ],
    "_population": 209,
    "_hsl": [
      0.06060606060606059,
      0.0431372549019608,
      0.5
    ]
  },
  "LightMuted": {
    "_rgb": [
      184,
      193,
      201
    ],
    "_population": 854,
    "_hsl": [
      0.5784313725490197,
      0.13599999999999993,
      0.7549019607843137
    ]
  },
  "DarkMuted": {
    "_rgb": [
      55,
      73,
      88
    ],
    "_population": 407,
    "_hsl": [
      0.5757575757575758,
      0.23076923076923073,
      0.2803921568627451
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Fifty-Shades-Freed.js